import { usePodcastStore } from '../../Disciplines/stores/podcastsStore';
import { useSubjectStore } from '../../Disciplines/stores/subjectStore';
import { ISearchResult } from '../models';

export const categoryIcon = (category: string): string => {
  switch (category) {
    case 'workbook':
      return 'article';
    case 'mindmap':
      return 'article';
    case 'exercise':
      return 'edit';
    case 'lesson':
      return 'play_circle';
    case 'podcast':
      return 'mic';
    default:
      return 'article';
  }
};

export const categoryURL = (obj: ISearchResult): string => {
  const setContentType = useSubjectStore.getState().setContentType;
  const setActive = usePodcastStore.getState().setPodcast;

  const { discipline, subarea, subject, slug, type } = obj;

  switch (type) {
    case 'workbook':
      return `/disciplinas/${discipline?.slug}/modulo/${subarea?.slug}/assunto/${subject?.slug}/material/${slug}`;
    case 'mindmap':
      return `/disciplinas/${discipline?.slug}/modulo/${subarea?.slug}/assunto/${subject?.slug}/material/${slug}`;
    case 'exercise':
      return `/disciplinas/${discipline?.slug}/modulo/${subarea?.slug}/assunto/${subject?.slug}/exercicio/${slug}`;
    case 'lesson':
      return `/disciplinas/${discipline?.slug}/modulo/${subarea?.slug}/assunto/${subject?.slug}/videoaula/${slug}`;
    case 'lives':
      return `/ao-vivo/lives/${slug}`;
    case 'Audio':
      return `/disciplinas/${discipline?.slug}/modulo/${subarea?.slug}/tipo/podcast?slug=${slug}`;
    case 'podcast': {
      if (obj) {
        setContentType('podcast');
        setActive(obj);
      }

      return `/disciplinas/${discipline?.slug}/modulo/${subarea?.slug}/tipo/podcast?slug=${slug}`;
    }
    default:
      return '#';
  }
};

export const convertType = (type: string) => {
  if (type === 'lesson') {
    return 'Videoaula';
  }

  if (type === 'exercise') {
    return 'Exercicío';
  }

  if (type === 'podcast') {
    return 'Podcast';
  }

  if (type === 'mindmap' || type === 'workbook') {
    return 'Material';
  }

  if (type === 'practiceTest') {
    return 'Teste prático';
  }

  if (type === 'lives') {
    return 'Live';
  }

  return 'Material';
};

export const getFilterType = (type: string) => {
  if (type === 'lesson') {
    return 'Videoaula';
  }

  if (type === 'exercise') {
    return 'Exercicío';
  }

  if (type === 'podcast') {
    return 'Podcast';
  }

  if (type === 'mindmap') {
    return 'Mapa mental';
  }

  if (type === 'workbook') {
    return 'Material';
  }

  if (type === 'practiceTest') {
    return 'Teste prático';
  }

  if (type === 'lives') {
    return 'Live';
  }

  return type;
};
